import React from 'react'

export default function EmptyCredit({ colSpan }) {
    return (
        <>
            <tr>
                <td colSpan={colSpan}>
                    <div style={{ width: "100%", height: "auto", display: 'flex', justifyContent: 'center', padding: 30 }}>
                        <img style={{ width: '40%', height: '40%' }} src="https://static.vecteezy.com/system/resources/previews/009/467/877/non_2x/clipboard-and-pen-for-to-do-list-concept-illustration-flat-design-eps10-modern-graphic-element-for-landing-page-empty-state-ui-infographic-icon-vector.jpg" />
                    </div>
                </td>
            </tr>
        </>
    )
}
